<template>
  <header class="header" :class="{ scrolled: isScrolled }">
    <div class="logo">
      <router-link to="/"
        ><img src="@/assets/pic/logo.png" alt="YumEat Logo" class="logo-img"
      /></router-link>
    </div>

    <nav class="nav-links">
      <ul>
        <li><router-link to="/">Home</router-link></li>
        <li><router-link to="/features">Features</router-link></li>
        <li><router-link to="/how-to-work">How It Works</router-link></li>
      </ul>
    </nav>

    <div class="contact-button">
      <router-link to="/contact-us" class="btn-contact">Contact Us</router-link>
    </div>

    <button
      class="hamburger-menu"
      @click="openMenu"
      :class="{ hidden: isMobileMenuOpen }"
      aria-label="Toggle navigation"
    >
      <img src="@/assets/pic/hambr.png" alt="Menu Icon" />
    </button>

    <!-- القائمة الجانبية الجديدة للجوال -->
    <nav class="mobile-nav-links" :class="{ active: isMobileMenuOpen }">
      <div class="mobile-menu-header">
        <router-link to="/" @click="closeMenu" class="mobile-menu-title"
          >YumEat</router-link
        >
        <button
          @click="closeMenu"
          class="close-menu-btn"
          aria-label="Close menu"
        >
          &times;
        </button>
      </div>
      <ul>
        <li><router-link to="/" @click="closeMenu">Home</router-link></li>
        <li>
          <router-link to="/features" @click="closeMenu">Features</router-link>
        </li>
        <li>
          <router-link to="/how-to-work" @click="closeMenu"
            >How It Works</router-link
          >
        </li>
      </ul>
      <div class="mobile-social-icons">
        <a href="#" aria-label="Google"
          ><img src="@/assets/pic/google.png" alt="Google"
        /></a>
        <a href="#" aria-label="Facebook"
          ><img src="@/assets/pic/face.png" alt="Facebook"
        /></a>
        <a href="#" aria-label="Apple"
          ><img src="@/assets/pic/apple.png" alt="Apple"
        /></a>
      </div>
      <router-link
        to="/contact-us"
        @click="closeMenu"
        class="btn-contact-mobile"
        >Contact Us</router-link
      >
    </nav>
  </header>
</template>

<script>
export default {
  name: "TheHeader",
  data() {
    return {
      isMobileMenuOpen: false,
      isScrolled: false,
    };
  },
  mounted() {
    // إضافة مستمع لحدث التمرير عند تحميل المكون
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeUnmount() {
    // إزالة المستمع عند إزالة المكون لمنع تسرب الذاكرة
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    openMenu() {
      this.isMobileMenuOpen = true;
    },
    closeMenu() {
      this.isMobileMenuOpen = false;
    },
    // دالة للتحقق من موضع التمرير
    handleScroll() {
      // إذا كان التمرير أكبر من 10 بكسل، قم بتغيير الحالة
      this.isScrolled = window.scrollY > 10;
    },
  },
};
</script>

<style scoped>
/* 
  هذا النمط يستهدف الكلاس الذي يطبقه Vue Router تلقائيًا للرابط النشط بالضبط.
  سيتم تطبيقه على الروابط في قائمة التصفح لسطح المكتب والجوال.
*/
.nav-links a.router-link-exact-active {
  color: #ff4422; /* اللون البرتقالي للرابط النشط */
  font-weight: bold; /* جعل النص عريضًا ليبرز */
}

/* اختياري: إضافة تأثير انتقال ناعم لتغيير اللون بسلاسة عند التنقل */
.nav-links a,
.mobile-nav-links a {
  transition: color 0.3s ease;
}

/* تحريك الشعار لليمين قليلاً */
.logo {
  margin-left: 0; /* تم إزالة الهامش الإضافي ليتماشى مع الفيجما */
}

/* 
  هذا يضمن محاذاة جميع العناصر في الهيدر (الشعار، روابط التصفح، زر الاتصال)
  بشكل عمودي في المنتصف.
*/
.header {
  position: fixed; /* تغيير إلى fixed لجعله مستقلاً عن باقي العناصر */
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000; /* ضمان بقاء الهيدر فوق العناصر الأخرى */
  align-items: center;
  /* الحالة الافتراضية: شفاف وبدون ظل */
  background-color: transparent;
  box-shadow: none;
  /* تأثير انتقال ناعم عند تغيير الخلفية والظل */
  transition: background-color 0.3s ease, box-shadow 0.3s ease;
}

/* هذا النمط يتم تطبيقه فقط عند التمرير لأسفل */
.header.scrolled {
  background-color: #fff; /* خلفية بيضاء ثابتة */
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08); /* إضافة ظل ناعم */
}
/* 
  هذا يزيل الهامش الافتراضي للمتصفح من القائمة،
  والذي يمكن أن يتعارض مع محاذاة flexbox.
*/
.nav-links ul {
  margin: 0;
  padding: 0; /* إضافة هذا لإزالة الحشوة الافتراضية للقائمة */
}
</style>
